<!--
 * Path: packages/frontend/src/features/browser/forms/number/NumberRead.vue
 * Task: Display formatted numbers and currencies in read-only mode.
-->
<template>
  <div class="text-body-1 text-high-emphasis ms-1 mt-1 font-family-mono">
    {{ formattedValue }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue?: number | string | null;
  type: string;
}>();

const formattedValue = computed(() => {
  if (props.modelValue === null || props.modelValue === undefined || props.modelValue === '') {
    return '-';
  }

  const num = Number(props.modelValue);
  if (isNaN(num)) return String(props.modelValue);

  if (props.type === 'currency') {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(num);
  } else if (props.type === 'float') {
    return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(num);
  } else {
    // Integer
    return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(num);
  }
});
</script>

<style scoped>
.font-family-mono {
  font-family: monospace;
  font-size: 1rem !important;
}
</style>
